module.exports = {
          srcSet: __webpack_public_path__ + "274135e09ab442163c0e912a467104cc-14.png"+" 14w",
          images:[ {path: __webpack_public_path__ + "274135e09ab442163c0e912a467104cc-14.png",width: 14,height: 15}],
          src: __webpack_public_path__ + "274135e09ab442163c0e912a467104cc-14.png",
          toString:function(){return __webpack_public_path__ + "274135e09ab442163c0e912a467104cc-14.png"},
          
          width: 14,
          height: 15
        }